// Section metadata used by the admin nav + editors. Ordered like the site.
export const SECTIONS = [
  { key: "global", label: "Global", hint: "Calendly link, LinkedIn URL, headshot, page title.", fields: [
    { name: "calendly_url", label: "Calendly URL", type: "text" },
    { name: "linkedin_url", label: "LinkedIn URL", type: "text" },
    { name: "headshot_url", label: "Headshot URL or /api/uploads/... path", type: "image" },
    { name: "site_title", label: "Site title (browser tab)", type: "text" },
    { name: "site_description", label: "SEO meta description", type: "textarea" },
  ] },
  { key: "hero", label: "Hero", hint: "Top of the homepage.", fields: [
    { name: "eyebrow", label: "Eyebrow (small label)", type: "text" },
    { name: "headline_pre", label: "Headline start", type: "text" },
    { name: "headline_em", label: "Headline emphasis (magenta italic)", type: "text" },
    { name: "headline_post", label: "Headline end", type: "text" },
    { name: "paragraph1", label: "Supporting paragraph 1", type: "textarea" },
    { name: "paragraph2", label: "Supporting paragraph 2", type: "textarea" },
    { name: "primary_cta", label: "Primary button label", type: "text" },
    { name: "secondary_link", label: "Secondary link label", type: "text" },
  ] },
  { key: "social_proof", label: "Social proof bar", hint: "The line under the hero.", fields: [
    { name: "label", label: "Small label", type: "text" },
    { name: "orgs", label: "Organisations", type: "string_list" },
  ] },
  { key: "trust_strip", label: "Trust strip", hint: "The blush strip above About.", fields: [
    { name: "items", label: "Items", type: "object_list", schema: [
      { name: "headline", label: "Headline", type: "text" },
      { name: "sub", label: "Sub-text", type: "text" },
    ] },
  ] },
  { key: "about", label: "About Rochelle", fields: [
    { name: "eyebrow", label: "Eyebrow", type: "text" },
    { name: "heading_pre", label: "Heading start", type: "text" },
    { name: "heading_em", label: "Heading emphasis", type: "text" },
    { name: "paragraphs", label: "Bio paragraphs", type: "string_list", multiline: true },
    { name: "linkedin_label", label: "LinkedIn link label", type: "text" },
  ] },
  { key: "why", label: "Why work with me", fields: [
    { name: "eyebrow", label: "Eyebrow", type: "text" },
    { name: "heading_pre", label: "Heading start", type: "text" },
    { name: "heading_em", label: "Heading emphasis", type: "text" },
    { name: "body", label: "Body copy", type: "textarea" },
  ] },
  { key: "services", label: "Services", fields: [
    { name: "eyebrow", label: "Eyebrow", type: "text" },
    { name: "heading", label: "Section heading", type: "textarea" },
    { name: "cards", label: "Service cards", type: "object_list", schema: [
      { name: "icon", label: "Icon (clipboard | megaphone | heart | pen | users | sparkles | star | flag | briefcase)", type: "text" },
      { name: "title", label: "Title", type: "text" },
      { name: "body", label: "Body", type: "textarea" },
    ] },
    { name: "cta_lede", label: "CTA lede", type: "textarea" },
    { name: "cta_label", label: "CTA button label", type: "text" },
  ] },
  { key: "how", label: "How we can work together", fields: [
    { name: "eyebrow", label: "Eyebrow", type: "text" },
    { name: "heading", label: "Heading", type: "text" },
    { name: "supporting", label: "Supporting copy", type: "textarea" },
    { name: "options", label: "Options", type: "object_list", schema: [
      { name: "n", label: "Number label", type: "text" },
      { name: "title", label: "Title", type: "text" },
      { name: "body", label: "Body", type: "text" },
    ] },
  ] },
  { key: "testimonials", label: "Testimonials", fields: [
    { name: "eyebrow", label: "Eyebrow", type: "text" },
    { name: "heading", label: "Heading", type: "text" },
    { name: "items", label: "Testimonials (first 3 shown on homepage)", type: "object_list", schema: [
      { name: "quote", label: "Quote", type: "textarea" },
      { name: "name", label: "Name", type: "text" },
      { name: "role", label: "Role", type: "text" },
      { name: "org", label: "Organisation", type: "text" },
    ] },
    { name: "orgs_line", label: "Organisations line", type: "textarea" },
  ] },
  { key: "mission_vision", label: "Mission & Vision", fields: [
    { name: "mission_eyebrow", label: "Mission eyebrow", type: "text" },
    { name: "mission_pre", label: "Mission start", type: "textarea" },
    { name: "mission_em", label: "Mission emphasis", type: "text" },
    { name: "vision_eyebrow", label: "Vision eyebrow", type: "text" },
    { name: "vision_pre", label: "Vision start", type: "textarea" },
    { name: "vision_em", label: "Vision emphasis", type: "text" },
    { name: "vision_post", label: "Vision end", type: "text" },
  ] },
  { key: "contact", label: "Contact section", fields: [
    { name: "eyebrow", label: "Eyebrow", type: "text" },
    { name: "heading_pre", label: "Heading start", type: "text" },
    { name: "heading_em", label: "Heading emphasis", type: "text" },
    { name: "lede", label: "Lede", type: "textarea" },
    { name: "secondary_note", label: "Form intro line", type: "text" },
    { name: "calendly_note", label: "Small line under Calendly button", type: "text" },
    { name: "success_heading", label: "Form success heading", type: "text" },
    { name: "success_body", label: "Form success body", type: "textarea" },
  ] },
  { key: "footer", label: "Footer", fields: [
    { name: "tagline", label: "Tagline", type: "textarea" },
    { name: "based_in_label", label: "\"Based in\" label", type: "text" },
    { name: "based_in", label: "Location text", type: "textarea" },
    { name: "acknowledgement", label: "Acknowledgement of Country", type: "textarea" },
    { name: "signature", label: "Signature", type: "text" },
  ] },
];

export const findSection = (key) => SECTIONS.find((s) => s.key === key);
